import {profileApi} from "./profile-api";
import {
  setFavoriteYachts, setIsMoreLicenses, setIsMoreTeam, setIsMoreYachts,
  setIytLicenses,
  setLicenses,
  setResume,
  setResumeCharters,
  setResumeLicenses,
  setSharedResume, setTeam
} from "./profile-actions";
import {userApi} from "../user/user-api";
import instance from "../instance";
import {dataApi} from "../data/data-api";


export const getLicenses = (offset) => async (dispatch, getState) => {
  console.log('here')
  const {user} = getState().userReducer
  let {licenses} = getState().profileReducer
  licenses = licenses !== null ? licenses : []
  try {
    const response = await profileApi.getLicenses(user.id, offset)
    if(response.data.length === 0 || response.data.length !== 10) dispatch(setIsMoreLicenses(false))
    let newLicenses = []
    for (const license of response.data) {
      let frontData, backData
      if (license.front_image_id) {
        frontData = await userApi.getFile(license.front_image_id)
      }
      if (license.back_image_id) {
        backData = await userApi.getFile(license.back_image_id)
      }
      newLicenses = [...newLicenses, {
        ...license,
        front_image: frontData ? Buffer.from(frontData.data, 'binary').toString('base64') : null,
        back_image: backData ? Buffer.from(backData.data, 'binary').toString('base64') : null
      }]
    }
    dispatch(setLicenses([...{licenses: offset ? licenses : []}.licenses, ...newLicenses]))
  } catch (e) {
    dispatch(setLicenses(licenses))
  }
}

export const addLicense = (values) => async (dispatch, getState) => {
  const {user} = getState().userReducer
  const {licenses} = getState().profileReducer
  const response = await profileApi.addLicense(user.id, values)
  dispatch(setLicenses([...licenses, response.data]))
  let frontData, backData
  if(response.data.front_image_id) {
    frontData = await userApi.getFile(response.data.front_image_id)
  }
  if(response.data.back_image_id) {
    backData = await userApi.getFile(response.data.back_image_id)
  }
  dispatch(setLicenses([...licenses, {
    ...response.data,
    front_image: frontData ? Buffer.from(frontData.data, 'binary').toString('base64') : null,
    back_image: backData ? Buffer.from(backData.data, 'binary').toString('base64') : null,
  }]))
}

export const editLicense = (values, licenseId) => async (dispatch, getState) => {
  const {user} = getState().userReducer
  let {licenses} = getState().profileReducer
  try {
    const response = await profileApi.editLicense(user.id, licenseId, values)
    let frontData, backData = null
    if(response.data.front_image_id) {
      frontData = await userApi.getFile(response.data.front_image_id)
    }
    if(response.data.back_image_id) {
      backData = await userApi.getFile(response.data.back_image_id)
    }
    licenses = licenses.map((lic) => {
      if(lic.id === licenseId) {
        return {
          ...response.data,
          front_image: frontData !== null ? Buffer.from(frontData.data, 'binary').toString('base64') : null,
          back_image: backData !== null ? Buffer.from(backData.data, 'binary').toString('base64') : null,
        }
      } else {
        return lic
      }
    })
    dispatch(setLicenses([...licenses]))
  } catch(e) {
    console.log(e)
  }
}

export const deleteLicense = (licenseId) => async (dispatch, getState) => {
  const {user} = getState().userReducer
  const {licenses} = getState().profileReducer
  await profileApi.deleteLicense(user.id, licenseId)
  dispatch(setLicenses([...licenses].filter(l => l.id !== licenseId)))
}

export const getResume = () => async (dispatch) => {
  try {
    const response = await profileApi.getDraftResume()
    console.log(response.data)
    dispatch(setResume(response.data))
  } catch (e) {
    dispatch(setResume(null))
  }
}
export const updateResume = (values) => async (dispatch) => {
  const response = await profileApi.updateResume(values)
  dispatch(setResume(response.data))
}
export const addResumeLicenses = (licenseIds) => async (dispatch) => {
  const response = await profileApi.addResumeLicenses(licenseIds)
  dispatch(setResumeLicenses(response.data))
}
export const getResumeLicenses = () => async (dispatch) => {
  try {
    const response = await profileApi.getResumeLicenses()
    dispatch(setResumeLicenses(response.data))
  } catch (e) {
    dispatch(setResumeLicenses([]))
  }
}
export const addResumeCharters = (charterIds) => async (dispatch) => {
  const response = await profileApi.addResumeCharters(charterIds)
  dispatch(setResumeLicenses(response.data))
}
export const getResumeCharters = () => async (dispatch) => {
  try {
    const response = await profileApi.getResumeCharters()
    dispatch(setResumeCharters(response.data))
  } catch (e) {
    dispatch(setResumeCharters([]))
  }
}
export const sendResume = (body) => async (dispatch, getState) => {
  const {resume} = getState().profileReducer
  const response = await profileApi.sendResume(resume?.id, body)
  console.log(response.data)
}
export const getIytLicenses = (iytId) => async (dispatch, getState) => {
  const {profile} = getState().userReducer
  const {licenses} = getState().profileReducer
  try {
    const response = await profileApi.getIytLicenses(iytId, profile.id)
    let iytLicenses = []
    for(let license of response.data) {
      if(licenses.find(lic => lic.license_number === license.license_number) === undefined) {
        iytLicenses = [...iytLicenses, license]
      }
    }
    dispatch(setIytLicenses(iytLicenses))
  } catch (e) {
    dispatch(setIytLicenses([]))
  }
}
export const addIytLicenses = (iytLicenses) => async (dispatch, getState) => {
  const {profile} = getState().userReducer
  const {licenses} = getState().profileReducer
  let newLicenses = []
  for (let iytLicense of iytLicenses) {
    const response = await profileApi.addLicense(profile.id, {
      expiry_date: iytLicense.expiry_date,
      instructor_name: iytLicense.instructor_name,
      issue_date: iytLicense.issue_date,
      license_number: iytLicense.license_number,
      license_system_id: iytLicense.license_system_id,
      license_type_id: iytLicense.license_type_id,
      name: `${iytLicense.issue_date}-${iytLicense.expiry_date} ${iytLicense.license_number}`,
      school_name: iytLicense.school_name
    })
    newLicenses = [response.data, ...newLicenses]
    console.log(response.data)
  }
  dispatch(setLicenses([...newLicenses, ...licenses]))
}
export const getSharedResume = (resume_id) => async (dispatch) => {
  const response = await profileApi.getSharedResume(resume_id)
  dispatch(setSharedResume(response.data))
}

// favorite yachts

export const getFavoriteYachts = (offset) => async (dispatch, getState) => {
  const {profile} = getState().userReducer
  let {favoriteYachts} = getState().profileReducer
  favoriteYachts = favoriteYachts !== null ? favoriteYachts : []
  const response = await profileApi.getFavoriteYachts(profile.id, offset)
  if(response.data.length === 0 || response.data.length !== 10) dispatch(setIsMoreYachts(false))
  let yachts = []
  for (let item of response.data) {
    try {
      let yachtImage
      if(item.yacht.yacht_image_id) {
        yachtImage = await userApi.getFile(item.yacht.yacht_image_id)
      }
      yachts = [...yachts, {...item, image: yachtImage ? Buffer.from(yachtImage.data, 'binary').toString('base64') : undefined}]
    } catch (e) {
      yachts = [...yachts, {...item, image : undefined}]
    }
  }
  dispatch(setFavoriteYachts([...{yachts: offset ? favoriteYachts : []}.yachts, ...yachts]))
}

export const deleteFavoriteYacht = (yachtId) => async (dispatch, getState) => {
  const {profile} = getState().userReducer
  const {favoriteYachts} = getState().profileReducer
  const response = await profileApi.deleteFavoriteYacht(profile.id, yachtId)
  dispatch(setFavoriteYachts([...favoriteYachts].filter(f => f.yacht_id !== yachtId)))
}
export const addFavoriteYacht = (body) => async (dispatch, getState) => {
  const {profile} = getState().userReducer
  const {favoriteYachts} = getState().profileReducer
  const response = await dataApi.addYacht(body)
  if(!body.editYachtId) {//if edit
    const res = await profileApi.addFavoriteYacht(response.data.id, profile.id)
    let image
    try {
      image = await userApi.getFile(response.data.yacht_image_id)
    } catch (e) {}
    dispatch(setFavoriteYachts([...favoriteYachts, {
      ...res.data,
      image: image ? Buffer.from(image.data, 'binary').toString('base64') : undefined
    }]))
  } else {//if add
    let yachts = []
    for (let yacht of favoriteYachts) {
      if(yacht.yacht_id === response.data.id) {
        let image
        try {
          image = await userApi.getFile(response.data.yacht_image_id)
        } catch (e) {}
        yachts = [...yachts, {
          ...yacht,
          yacht: {...response.data},
          yacht_id: response.data.id,
          image: image ? Buffer.from(image.data, 'binary').toString('base64') : undefined
        }]
      } else {
        yachts = [...yachts, yacht]
      }
    }
    dispatch(setFavoriteYachts(yachts))
  }
}

export const getTeam = () => async (dispatch) => {
  const response = await profileApi.getTeam()
  dispatch(setTeam(response.data))
  if(response.data.length === 0 || response.data.length !== 10) dispatch(setIsMoreTeam(false))
}
